export const opts = {}
export const strings = {}
export const colors = {}

export const setOpts = optsConstants => {
	Object.assign(opts, optsConstants)
}

export const setColors = colorsConstants => {
	Object.assign(colors, colorsConstants)
}

export const setStringConstants = stringConstants => {
	Object.assign(strings, stringConstants)
}

export const getOpts = opt => {
	if(typeof opts[opt] !== 'undefined')
		return opts[opt]

	return null
}

export const getColor = color => {
	if(typeof colors[color] !== 'undefined')
		return colors[color]

	return null
}

export const getString = string => {
	if(typeof strings[string] !== 'undefined')
		return strings[string]

	return null
}



// WEBPACK FOOTER //
// ./app/utils/constants.js